function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.005,46.571c-1.657,0-3,1.343-3,3V75H6V24.596h55.821c1.656,0,3-1.344,3-3c0-1.657-1.344-3-3-3H43.878 l-9.361-9.361c-0.563-0.563-1.326-0.879-2.122-0.879H3c-1.657,0-3,1.343-3,3v9.533c0,0.121,0.022,0.236,0.036,0.354 C0.022,21.359,0,21.475,0,21.596V78c0,1.657,1.343,3,3,3h87.005c1.657,0,3-1.343,3-3V49.571 C93.005,47.914,91.662,46.571,90.005,46.571 M31.153,14.356l4.238,4.24H6v-4.24H31.153z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.983,0C78.097,0,68.426,9.671,68.426,21.558s9.671,21.558,21.558,21.558s21.559-9.671,21.559-21.558 S101.87,0,89.983,0 M89.983,37.116c-8.579,0-15.558-6.979-15.558-15.558C74.426,12.979,81.404,6,89.983,6 s15.559,6.979,15.559,15.558C105.542,30.137,98.563,37.116,89.983,37.116"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.812,19.558h-7.828V11.73c0-1.104-0.896-2-2-2s-2,0.896-2,2v7.828h-7.827c-1.105,0-2,0.896-2,2 s0.895,2,2,2h7.827v7.828c0,1.104,0.896,2,2,2s2-0.896,2-2v-7.828h7.828c1.104,0,2-0.896,2-2S100.915,19.558,99.812,19.558"
});

var SvgNuovaCartella = function SvgNuovaCartella(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 112,
    height: 82,
    viewBox: "-0.136 -0.499 112 82",
    enableBackground: "new -0.136 -0.499 112 82",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNuovaCartella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nuovaCartella.c64e3295.svg";
export { ForwardRef as ReactComponent };